import { render, staticRenderFns } from "./DocumentsToolbar.vue?vue&type=template&id=3ef9e04c&scoped=true"
import script from "./DocumentsToolbar.vue?vue&type=script&lang=js"
export * from "./DocumentsToolbar.vue?vue&type=script&lang=js"
import style0 from "./DocumentsToolbar.vue?vue&type=style&index=0&id=3ef9e04c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef9e04c",
  null
  
)

export default component.exports